import { render, staticRenderFns } from "./MessageIncomingImage.vue?vue&type=template&id=1a7c88ff&"
import script from "./MessageIncomingImage.vue?vue&type=script&lang=js&"
export * from "./MessageIncomingImage.vue?vue&type=script&lang=js&"
import style0 from "./MessageIncomingImage.vue?vue&type=style&index=0&id=1a7c88ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDialog,VImg})
